import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram } from 'lucide-react';
import { siteData } from '../mockData';
import { cities } from '../data/cities';

const FOOTER_CITY_KEYS = [
  'tacoma', 'seattle', 'lakewood', 'bellevue',
  'puyallup', 'kent', 'renton', 'auburn',
  'federal-way', 'university-place', 'pierce-county', 'king-county',
];

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {/* Left - Logo */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start space-x-3">
              <img
                src={siteData.images.nameLogo}
                alt="Mazen El-Majzoub Real Estate logo"
                width="60"
                height="60"
                className="h-[60px] w-auto"
                style={{ filter: 'invert(1)' }}
              />
              <div>
                <div className="text-sm font-semibold tracking-wide whitespace-nowrap">MAZEN EL-MAJZOUB</div>
                <div className="text-xs tracking-widest text-gray-400 whitespace-nowrap">REDEFINING EXCELLENCE</div>
              </div>
            </div>
          </div>

          {/* Center - Contact Info */}
          <div className="text-center space-y-2">
            <p className="text-sm">
              Call: <a href={`tel:+12533159480`} className="hover:text-gray-300 transition-colors">{siteData.agent.phone.mobile}</a>
            </p>
            <p className="text-sm">
              Text: <a href="sms:+12533159480" className="hover:text-gray-300 transition-colors">{siteData.agent.phone.mobile}</a>
            </p>
            <p className="text-sm">
              <a href={`mailto:${siteData.agent.email}`} className="hover:text-gray-300 transition-colors">{siteData.agent.email}</a>
            </p>
            <p className="text-sm text-gray-400">
              4928 109th St SW, Lakewood, WA 98499
            </p>
          </div>

          {/* Right - PRP Logo & Social */}
          <div className="text-center md:text-right space-y-4">
            <div className="flex justify-center md:justify-end">
              <img
                src={siteData.images.prpLogo}
                alt="Premier Real Estate Partners"
                width="130"
                height="64"
                className="h-16 w-auto" />

            </div>
            
            {/* Social Media Icons */}
            <div className="flex justify-center md:justify-end space-x-4">
              <a
                href={`${siteData.socialMedia.facebook}?utm_source=mazenelmajzoub.com&utm_medium=social&utm_campaign=footer`}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 border-2 border-white rounded-full hover:bg-white hover:text-gray-900 transition-all duration-300"
                aria-label="Facebook">

                <Facebook size={20} />
              </a>
              <a
                href={`${siteData.socialMedia.instagram}?utm_source=mazenelmajzoub.com&utm_medium=social&utm_campaign=footer`}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 border-2 border-white rounded-full hover:bg-white hover:text-gray-900 transition-all duration-300"
                aria-label="Instagram">

                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Service Areas */}
        <div className="mt-10 pt-8 border-t border-gray-800">
          <p className="text-xs tracking-[0.3em] text-gray-500 uppercase mb-4 text-center md:text-left">Service Areas</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-6 gap-y-2 text-sm">
            {FOOTER_CITY_KEYS.map((key) => {
              const c = cities[key];
              if (!c) return null;
              return (
                <Link
                  key={key}
                  to={`/${c.slug}`}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  {c.name}
                </Link>
              );
            })}
          </div>
        </div>

        {/* Legal / Compliance */}
        <div className="mt-8 pt-8 border-t border-gray-700 text-center">
          <div className="flex flex-wrap justify-center items-center gap-4 text-xs text-gray-400 mb-5">
            <span
              className="inline-flex items-center gap-2 px-3 py-1.5 border border-gray-600 rounded"
              title="Equal Housing Opportunity"
            >
              <span className="inline-block w-4 h-4 border border-gray-400 rounded-sm relative">
                <span className="absolute inset-0 flex items-center justify-center text-[9px] leading-none">=</span>
              </span>
              Equal Housing Opportunity
            </span>
          </div>

          <p className="text-xs text-gray-500 leading-relaxed max-w-3xl mx-auto mb-4">
            Mazen El-Majzoub is a licensed real estate broker in the State of Washington
            (License # <span className="text-gray-400">22017872</span>),
            affiliated with Premier Real Estate Partners, 4928 109th St SW, Lakewood, WA
            98499. All brokerage services are provided through Premier Real Estate
            Partners. Each office is independently owned and operated.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400">
            <Link to="/terms" className="hover:text-white transition-colors">Terms Of Use</Link>
            <span>|</span>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
          </div>
          <p className="mt-4 text-xs text-gray-500">
            © {new Date().getFullYear()} Mazen El-Majzoub Real Estate. All rights reserved.
          </p>
        </div>
      </div>
    </footer>);

};

export default Footer;